import { createActions } from 'reduxsauce'
 
export const { Types, Creators } = createActions({
  uploadDocument: ['payload', 'requestId'],
  uploadDocumentSuccess: ['responseData'],
  uploadDocumentFailure: ['error'],
  
}, {});

